export type OrderStatusType = { label: string; value: string; icon: string }

// 品类商品
export const orderStatusList: OrderStatusType[] = [
  {
    label: '全部',
    value: '',
    icon: 'qb-icon.png',
  },
  {
    label: '待确认',
    value: 'DQR',
    icon: 'dqr-icon.png',
  },
  {
    label: '待使用',
    value: 'DSY',
    icon: 'dsy-icon.png',
  },
  {
    label: '已完成',
    value: 'YWC',
    icon: 'ywc-icon.png',
  },
  {
    label: '售后取消', // 原名售后退款
    value: 'SHTK',
    icon: 'shtk-icon.png',
  },
]

// 实物商品
export const physcialGoodsOrderStatusList: OrderStatusType[] = [
  {
    label: '全部',
    value: '',
    icon: 'qb-icon.png',
  },
  {
    label: '待发货',
    value: 'DFH',
    icon: 'dqr-icon.png',
  },
  {
    label: '待收货',
    value: 'DSH',
    icon: 'dqr-icon.png',
  },
  {
    label: '已完成',
    value: 'YWC',
    icon: 'ywc-icon.png',
  },
  {
    label: '售后取消', // 原名售后退款
    value: 'SSHTK',
    icon: 'shtk-icon.png',
  },
]
